import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBilling } from '../../context/BillingContext';
import { SubscriptionPlans } from './SubscriptionPlans';
import { CurrentSubscription } from './CurrentSubscription';
import { PaymentMethodList } from './PaymentMethodList';
import './BillingPage.css';

type BillingTab = 'overview' | 'plans' | 'payment' | 'history';

export function BillingPage() {
  const navigate = useNavigate();
  const { isLoading, error, subscription, refresh } = useBilling();
  const [activeTab, setActiveTab] = useState<BillingTab>('overview');

  if (isLoading) {
    return (
      <div className="billing-page">
        <div className="billing-loading">
          <div className="loading-spinner"></div>
          <p>Loading billing information...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="billing-page">
      <header className="billing-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          &larr; Back
        </button>
        <h1>Billing & Subscription</h1>
      </header>

      {error && (
        <div className="billing-error">
          <p>{error}</p>
          <button onClick={refresh}>Try Again</button>
        </div>
      )}

      <nav className="billing-tabs">
        <button
          className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          Overview
        </button>
        <button
          className={`tab-btn ${activeTab === 'plans' ? 'active' : ''}`}
          onClick={() => setActiveTab('plans')}
        >
          Plans
        </button>
        <button
          className={`tab-btn ${activeTab === 'payment' ? 'active' : ''}`}
          onClick={() => setActiveTab('payment')}
        >
          Payment Methods
        </button>
        <button
          className={`tab-btn ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => navigate('/billing/history')}
        >
          Billing History
        </button>
      </nav>

      <div className="billing-content">
        {activeTab === 'overview' && (
          <div className="billing-overview-tab">
            <CurrentSubscription />

            {!subscription && (
              <div className="upgrade-prompt">
                <h3>Upgrade Your Experience</h3>
                <p>Get access to premium features, ad-free gameplay, and exclusive content.</p>
                <button className="btn-primary" onClick={() => setActiveTab('plans')}>
                  View Plans
                </button>
              </div>
            )}
          </div>
        )}

        {activeTab === 'plans' && <SubscriptionPlans />}
        {activeTab === 'payment' && <PaymentMethodList />}
      </div>
    </div>
  );
}
